export default "__VITE_ASSET__B_Nn3ccD__"